import { Injectable, inject } from '@angular/core';
import {
    IInterpolationFragmentService,
    InterpolationFragment,
    InterpolationFragmentType,
    SystemEntity,
    TokenParts,
} from '@wdx/shared/utils';
import { EntityRouteService } from './entity-route';
import { RoutableSystemEntity } from '@wdx/clmi/utils/models';

@Injectable({
    providedIn: 'root',
})
export class InterpolationFragmentService extends IInterpolationFragmentService {
    private entityRouteService = inject(EntityRouteService);

    convertTokenPartsToFragment(
        parts: TokenParts,
        entityId: string,
    ): InterpolationFragment {
        if ([parts.name, parts.id, parts.type].every((item) => !item)) {
            return {
                type: InterpolationFragmentType.Text,
                value: parts.token,
            };
        }

        // if this is a download notification
        if (parts.name === 'fileindex') {
            return {
                type: InterpolationFragmentType.FileDownload,
                value: parts.id,
                fileIndex: parts.type,
            };
        }

        // if this is a link notification
        if ([parts.name, parts.id, parts.type].every(Boolean)) {
            const entityType = parts.type as SystemEntity;
            const newEntityId =
                entityType === SystemEntity.WorkItem ? entityId : parts.id;
            const value = parts.name;

            let subEntityType: string | undefined;
            let subEntityId: string | undefined;

            if (entityType === SystemEntity.WorkItem) {
                subEntityType = parts.type;
                subEntityId = parts.id;
            }

            const routeWithParams =
                this.entityRouteService.routeWithParamsForEntity(
                    entityType,
                    newEntityId,
                    undefined,
                    subEntityType as RoutableSystemEntity,
                    subEntityId,
                );

            return {
                type: InterpolationFragmentType.Link,
                value,
                entityType,
                entityId: newEntityId,
                subEntityType,
                subEntityId,
                routerLink: routeWithParams.routerLink ?? undefined,
                queryParams: routeWithParams.queryParams ?? undefined,
            };
        }

        return {
            type: InterpolationFragmentType.Text,
            value: parts.token,
        };
    }
}
